import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fb85d14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-3" }
const _hoisted_2 = { class: "container-lg container-fluid" }
const _hoisted_3 = { class: "card border-0" }
const _hoisted_4 = { class: "row mb-md-3 mb-1" }
const _hoisted_5 = { class: "col-lg-10 col-12 mx-auto" }
const _hoisted_6 = { class: "card-body shadow px-4 my-3 bg-white rounded-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-start mb-3" }, "Health Directorate Invite", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HealthDirectorateInviteForm = _resolveComponent("HealthDirectorateInviteForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_HealthDirectorateInviteForm)
            ])
          ])
        ])
      ])
    ])
  ]))
}